import { Injectable } from '@angular/core';
import { DatabaseService } from './database.service';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(
    private databaseService: DatabaseService,
    private router: Router,
    private snackBar: MatSnackBar
  ) {}

  /**
   * Verifica si el usuario tiene acceso a un menú específico
   * @param sessionId ID de la sesión del usuario
   * @param menuId ID del menú a verificar
   * @returns Observable<boolean>
   */
  getMenusRutaModulos(sessionId: number, menuId: number): Observable<boolean> {
    let val = false;
    const menuArbol = JSON.parse(localStorage.getItem('menuArbol') || '[]');
    const idExists = this.searchId(menuArbol, menuId);

    if (idExists) {
      val = true;
      return of(val);
    } else {
      if (val == false) {
        this.showAccessDeniedMessage(val);
        // No redirigir a login, solo mostrar el mensaje de acceso denegado
        // Keycloak manejará la autenticación si es necesario
      }
      return of(val);
    }
  }

  /**
   * Verifica recursivamente si un menú está disponible en el árbol de menús
   * @param menuItems Array de elementos del menú
   * @param menuId ID del menú a buscar
   * @returns boolean
   */
  private checkMenuAccess(menuItems: any[], menuId: number): boolean {
    for (const item of menuItems) {
      // Verificar si el elemento actual coincide
      if (item.id === menuId) {
        return true;
      }
      
      // Si tiene subelementos, buscar recursivamente
      if (item.subItems && item.subItems.length > 0) {
        if (this.checkMenuAccess(item.subItems, menuId)) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Limpia la sesión (placeholder para futuras implementaciones)
   * @param sessionId ID de la sesión
   */
  CleanSession(sessionId: number): void {
    // Implementar lógica de limpieza de sesión si es necesario
    console.log(`Cleaning session for user: ${sessionId}`);
  }

  /**
   * Obtiene los permisos del usuario
   * @param sessionId ID de la sesión
   * @returns Observable con los permisos
   */
  getUserPermissions(sessionId: number): Observable<any> {
    return this.databaseService.sendToMicroservice('employees', 'get_permissions', {
      employeeId: sessionId
    });
  }

  /**
   * Verifica si el usuario tiene un permiso específico
   * @param permissionName Nombre del permiso
   * @returns boolean
   */
  hasPermission(permissionName: string): boolean {
    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    return permissions.includes(permissionName);
  }

  /**
   * Obtiene el menú del usuario desde el servidor
   * @param sessionId ID de la sesión
   * @returns Observable con el menú
   */
  getUserMenu(sessionId: number): Observable<any> {
    return this.databaseService.sendToMicroservice('employees', 'get_available_menus', {
      employeeId: sessionId
    });
  }

  /**
   * Busca recursivamente un ID en el árbol de menús
   * @param menuItems Array de elementos del menú
   * @param id ID a buscar
   * @returns boolean
   */
  private searchId(menuItems: any[], id: number): boolean {
    for (const item of menuItems) {
      // Verificar si el elemento actual coincide
      if (item.id === id) {
        return true;
      }
      
      // Si tiene subelementos, buscar recursivamente
      if (item.subItems && item.subItems.length > 0) {
        if (this.searchId(item.subItems, id)) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Muestra el mensaje de acceso denegado
   * @param val Valor del acceso
   */
  private showAccessDeniedMessage(val: boolean): void {
    this.snackBar.open(`Acceso denegado [${val}]`, 'Cerrar', {
      duration: 5000,
      panelClass: ['error-snackbar']
    });
  }
}
